<template>  
  <div class="buyPro"> 
      <div class="main_page">
          <div class="buyPro_main">
						<div class="buyPro_left">
							<img class="buyPro_left_show" src="https://static.wixstatic.com/media/94387ac4a64f477a8a9aa8d1f657d20f.jpg/v1/fill/w_393,h_248,al_c,q_80,usm_0.66_1.00_0.01/Stock%20Market%20Graph.webp">
							<p class="describe">特许金融分析师（一级）</p>
							<ul>
								<li>课程时长：3个月</li>
								<li>课程时长：3个月</li>
								<li>课程时长：3个月</li>
								<li>课程时长：3个月</li>
							</ul>
							<div class="describe_img">
								<p>Morgan Stanley</p>
								<img src="https://static.wixstatic.com/media/a36401_830f1f96bf4b46578aa6780648f48a94~mv2.png/v1/fill/w_119,h_41,al_c,q_80,usm_0.66_1.00_0.01/2000px-London_school_of_economics_logo_w.webp">
							</div>
							<div class="photo">
								<img src="https://static.wixstatic.com/media/a36401_bf3b2dd9e1744bbe89747594703f933d~mv2_d_2162_3513_s_2.png/v1/fill/w_133,h_209,al_c,q_80,usm_0.66_1.00_0.01/purepng_com-business-manbusinessmanbusin.webp">
							</div>
						</div>
						<div class="buyPro_right">
							<p class="money">&yen;2899</p>
							<p class="money_describe">包含消费税约&yen;199</p>
							<ul>
								<li>内容包括：</li>
								<li>视频课程</li>
								<li>课程讲义及习题</li>
								<li>金融计算器</li>
								<li>毕业证书</li>
							</ul>
							<div v-if="!pay_QR_code" class="pay_content">
									<input type="text" placeholder="优惠码/CouponCode">
									<div class="pay_clause">
										<el-checkbox-group v-model="clause">
											<el-checkbox name="agree">同意MD College《付款及守候相关条款》</el-checkbox>
										</el-checkbox-group>
									</div>
									<div class="pay_mode">
										<ul>
											<li>
										  <img src="https://static.wixstatic.com/media/a36401_b77d1f1e062b47199189c3f10b367f62~mv2.png/v1/fill/w_41,h_41,al_c,q_80,usm_0.66_1.00_0.01/wechat-pay-logo.webp">
											<el-radio v-model="pay_mode" label="1" @change="select_pay">&nbsp;
											</el-radio>
										</li>	
										<li>
											<img src="https://static.wixstatic.com/media/a36401_332e43834f7a465bac6d812ed967f1ef~mv2.png/v1/fill/w_41,h_41,al_c,q_80,usm_0.66_1.00_0.01/alipay-1-569587.webp">
											<el-radio v-model="pay_mode" label="2"  @change="select_pay">&nbsp;
											</el-radio>
											</li>
											</ul>
									</div>
									<el-button round class="pay_btn" @click="go_pay">立即支付</el-button>
							</div>
						  <div v-if="pay_QR_code" class="pay_content">
								<img class="pay_QR_code_img" src="../../../static/images/edu_QR_code.png">
								<el-button round class="pay_btn" @click="back">返回</el-button>
							</div>	
						</div>
					</div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'buyPro',
  data () {
    return {
			clause:'',//付款及守候相关条款
			pay_mode:0,
			pay_QR_code:false
    }
  },
	methods:{
		select_pay:function(){
			alert(this.pay_mode)
		},
		go_pay:function(){
			alert('显示支付二维码')
			this.pay_QR_code = true
		},
		back:function(){
			this.pay_QR_code = false
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .buyPro{
    background-image: url(https://static.wixstatic.com/media/a36401_4635bf0cb41f4f1f9cbf65f56e592e95~mv2_d_7025_3011_s_4_2.jpg/v1/fill/w_1920,h_823,al_c,q_85,usm_0.66_1.00_0.01/a36401_4635bf0cb41f4f1f9cbf65f56e592e95~mv2_d_7025_3011_s_4_2.webp);
    background-repeat: no-repeat;
    background-size: cover;
    background-position: 0 0;
    position: relative;
    width: 100%;
  }
 .buyPro_main{
	 width: 1024px;
	 height: 700px;
	 margin:0 auto;
	 padding-top:200px;
	 color:#fff;
	 position: relative;
 }
 .buyPro_main .buyPro_left{
	 width:400px;
	 height: 580px;
	 position: absolute;
	 margin-left:30px;
	 background-color: #fff;
	 border-radius: 20px;
 }
 .buyPro_main .buyPro_left .describe{
 	 height: 20px;
 	 margin-top:20px;
 	 color:#414141;
 	 font-size:17px;
 	 text-align: center;
 }
 .buyPro_main .buyPro_left .buyPro_left_show{
	 width:400px;
	 height: 240px;
	 position:relative
 }
 .buyPro_main .buyPro_left ul{
	 width:300px;
	 height: 80px;
	 margin-top:30px;
	 margin-left:20px;
 }
 
 .buyPro_main .buyPro_left ul li{
	 width: 150px;
	 height: 40px;
	 line-height: 40px;
	 float: left;
	 color:#414141;
	 font-size:14px;
	 text-align: center;
 }
 .buyPro_main .buyPro_left .describe_img{
	 width: 280px;
	 margin-top:40px;
 }
 .buyPro_main .buyPro_left .describe_img p{
	 width: 280px;
	 height: 30px;
	 line-height: 30px;
	 color:#414141;
	 font-size:16px;
	 text-align: center;
 }
 .buyPro_main .buyPro_left .describe_img img{
	 width:140px;
	 height: 100%;
	 margin:20px auto;
 }
 .buyPro_main .buyPro_left .photo{
	 width: 100px;
	 height: 200px;
	 float: right;
	 margin-top:-170px;
	 margin-right:0;
 }
 .buyPro_main .buyPro_right{
	   width:320px;
		 height: 500px;
		 padding:40px;
		 float: right;
		 margin-right:30px;
		 background-color: rgba(0,0,0,0.5);
		 border-radius: 20px;;
	 }
	 .buyPro_main .buyPro_right .money{
			height: 50px;
			font-size: 50px;
			color:#fff;
	 }
	 .buyPro_main .buyPro_right .money_describe{
		 height: 14px;
		 line-height: 14px;
		 margin-top:20px;
		 font-size:11px;
		 color:#fff;
		 overflow: hidden;
     white-space: nowrap;
     text-overflow: ellipsis;
		} 
		.buyPro_main .buyPro_right ul{
			width: 100%;
			height: 150px;
			margin-top:20px;
			overflow: hidden;
			zoom:1;
		}	
		.buyPro_main .buyPro_right ul li{
			width: 100%;
			height: 20px;
			line-height: 20px;
			font-size:15px;
			color:#E8E6E6;
		}
		.buyPro_main .buyPro_right .pay_content input{
			width: 200px;
			height:30px;
			line-height: 30px;
			border-radius: 20px;
			margin:0 60px;
			border:0;
			text-indent: 20px;
		}
		.buyPro_main .buyPro_right .pay_content .pay_clause{
			margin-top:10px;
			text-align: center;
			font-size:11px;
		}
		.buyPro_main .buyPro_right .pay_content  .pay_mode{
			text-align: center;
		}
		.buyPro_main .buyPro_right .pay_content  .pay_mode ul{
			width: fit-content;
			height: 140px;
			overflow: hidden;
			position: relative;
			zoom: 1;
			margin:0 auto;
		}
		.buyPro_main .buyPro_right .pay_content  .pay_mode ul li{
			width: 100px;
			float: left;
			text-align: center;
		}
		.buyPro_main .buyPro_right .pay_content  .pay_mode ul li img{
			width: 40px;
			height: 40px;
			margin:30px 30px 20px 30px;
		}
		.buyPro_main .buyPro_right .pay_content .pay_btn{
			width: 80px;
			height: 30px;
			background-color: unset;
			font-size: 12px;
			color: #fff;
			border: 1px #fff solid;
			padding: 0;
			margin-left: 130px;
		}
		.buyPro_main .buyPro_right .pay_content .pay_btn:hover{
			background-color: #fff;
			color:#000;
		}
		.buyPro_main .buyPro_right .pay_content .pay_QR_code_img{
			width: 180px;
			height: 180px;
			margin-left:70px;
			margin-bottom:30px;
		}
</style>



// WEBPACK FOOTER //
// src/components/content/buyPro.vue